import { IValue } from "../core/ivalue";
/**
 * Declares a notifiable value
 * @class Reference
 * @extends IValue
 */
export class Reference extends IValue {
    /**
     * @param value {any} the initial value
     */
    constructor(value) {
        super(true);
        this.value = value;
        this.onchange = new Set;
        this.$seal();
    }
    get $() {
        return this.value;
    }
    set $(value) {
        if (this.value !== value) {
            this.value = value;
            if (this.isEnabled) {
                this.onchange.forEach(handler => {
                    handler(value);
                });
            }
        }
    }
    enable() {
        if (!this.isEnabled) {
            this.onchange.forEach(handler => {
                handler(this.value);
            });
            this.isEnabled = true;
        }
        return this;
    }
    disable() {
        this.isEnabled = false;
        return this;
    }
    on(handler) {
        this.onchange.add(handler);
        return this;
    }
    off(handler) {
        this.onchange.delete(handler);
        return this;
    }
    $destroy() {
        super.$destroy();
        this.onchange.clear();
    }
}
